import React, { createContext, useContext, useEffect, useState } from "react";
import { URLS } from "./Constant";
import { get } from "./ApiHandler";
import { useNavigate, useLocation } from "react-router-dom";
import useStore from "../Screen/redux/store/useStore";

const AppContext = createContext(null);

export const AppProvider = ({ children }) => {
  const [walletCount, setWalletCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [holidayReason, setHolidayReason] = useState("");
  const [triggerTimer, setTriggerTimer] = useState(false);
  const navigation = useNavigate();
  const location = useLocation();
  const { user } = useStore();
  const userId = user?.id;

  const value = {
    walletCount,
    setWalletCount,
    loading,
    setLoading,
    holidayReason,
    setHolidayReason,
    triggerTimer,
    setTriggerTimer,
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error("useAppContext must be used within AppProvider");
  }
  return context;
};
